import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { trackCalendlyConversion } from './GoogleTagLoader';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white/95 backdrop-blur-sm shadow-sm fixed top-0 left-0 right-0 z-50 transition-all duration-300" data-id="element-198">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="flex justify-between h-20 items-center" data-id="element-200">
          <div className="flex-shrink-0 flex items-center" data-id="element-201">
            <a href="#" className="text-2xl font-bold text-indigo-600" data-id="element-202">
              Turnout
            </a>
          </div>

          {/* Desktop menu */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-203">
            <a href="#features" className="text-gray-600 hover:text-indigo-600 px-3 py-2 text-sm font-medium transition-colors" data-id="element-204">
              Features
            </a>
            <a href="#case-studies" className="text-gray-600 hover:text-indigo-600 px-3 py-2 text-sm font-medium transition-colors" data-id="element-205">
              Case Studies
            </a>
            <a href="#about" className="text-gray-600 hover:text-indigo-600 px-3 py-2 text-sm font-medium transition-colors" data-id="element-206">
              About
            </a>
            <a href="#testimonials" className="text-gray-600 hover:text-indigo-600 px-3 py-2 text-sm font-medium transition-colors" data-id="element-207">
              Testimonials
            </a>
            <a href="https://calendly.com/dan-at-turnout/turnout-general-30-min-call" target="_blank" rel="noopener noreferrer" onClick={trackCalendlyConversion} className="ml-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 transition-colors shadow-sm" data-id="element-208">
              See How It Works
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-209">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" data-id="element-210">
              {isMenuOpen ? <X size={24} data-id="element-211" /> : <Menu size={24} data-id="element-212" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white shadow-lg border-t border-gray-100" data-id="element-213">
          <div className="px-4 pt-4 pb-6 space-y-2" data-id="element-214">
            <a href="#features" className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-215">
              Features
            </a>
            <a href="#case-studies" className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-216">
              Case Studies
            </a>
            <a href="#about" className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-217">
              About
            </a>
            <a href="#testimonials" className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-218">
              Testimonials
            </a>
            <div className="pt-4 mt-4 border-t border-gray-100" data-id="element-219">
              <a href="https://calendly.com/dan-at-turnout/turnout-general-30-min-call" target="_blank" rel="noopener noreferrer" onClick={() => {
            trackCalendlyConversion();
            setIsMenuOpen(false);
          }} className="block w-full text-center px-4 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 shadow-sm" data-id="element-220">
                See How It Works
              </a>
            </div>
          </div>
        </div>}
    </header>;
}